import {z} from '@hono/zod-openapi';

/**
 * Columns the card list can be ordered by. `manufacturer` is not among them: the row
 * carries only the manufacturer id and the label comes from a client-side codelist, so
 * ordering by it on the server would sort by id and look arbitrary on screen.
 */
export const DeadStockSortColumnSchema = z
  .enum([
    'catalogNumber',
    'name',
    'warehouseName',
    'quantity',
    'inventoryValue',
    'sellingPriceWithoutVat',
    'lastIssueDate',
    'bucket',
  ])
  .openapi('DeadStockSortColumn');

export type DeadStockSortColumn = z.infer<typeof DeadStockSortColumnSchema>;
